module.exports = __webpack_public_path__ + "static/img/2.a042f2ce.png";